import { defineMessages } from 'react-intl';

export const lineItemNameMessages = defineMessages({
  customProductName: {
    defaultMessage: 'Custom {product_name}',
    description: 'Lite item | Name | Custom product name',
  },
});
